import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  findAllRequestForSignetsApprovalsPageble,
  createRequestForSignetApproval,
  deleteRequestForSignetApproval,
  deleteErrorRequestForSignetApproval,
  changeRequestForSignetApprovalStatus,
  findAllRequestForSignetFilterPageable,
  findAllRequestForSignetsApprovalsByProcessor,
  findAllRequestForSignetsApprovalsByInspector,
  findAllRequestForSignetsApprovalsByClient,
} from '../../actions/requestForSignetApproval';
import RequestForSignetApprovalTable from '../RequestForSignetApproval/RequestForSignetApprovalTable';
import { TablePagination } from '@material-ui/core';
import LoadingIndicator from '../Reusable/LoadingIndicator';
import { rowsPerPageOptions, userRoles } from '../../constants/globals.js';
import {
  createComplementRequestApproval,
  findLastComplementRequestApprovalByRequestId,
  clearComplementRequestApproval,
} from '../../actions/complementRequestApproval';
import { changePaginationTextToSerbian, checkForUserRole } from '../../utils';
import withTranslations from '../../utils/HighOrderComponent';
import { createDecision } from '../../actions/decision';
import { findAllDecisionTypes } from '../../actions/decisionType';
import { deleteErrorDecision } from '../../actions/decision';

class RequestForSignetApprovalList extends Component {
  componentDidMount() {
    this.handleFindAllTrigger(0, this.props.pageSize);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetData) {
      const postData = {
        tableName: 'requestForSignetApproval',
        filterCriteria: [{ returnAllSignal: true }],
      };
      this.props.findAllRequestForSignetFilterPageable(
        0,
        nextProps.pageSize,
        postData
      );
      nextProps.setResetData(false);
    }
  }

  handleFindAllTrigger = (pageNumber, pageSize) => {
    const { loggedUser } = this.props || {},
      { roles, id } = loggedUser || {};
    if (checkForUserRole(roles, userRoles.AUTHORIZED_PERSON.value)) {
      this.props.findAllRequestForSignetsApprovalsByClient(
        id,
        pageNumber,
        pageSize
      );
    } else if (checkForUserRole(roles, userRoles.MDULS.value)) {
      this.props.findAllRequestForSignetsApprovalsByProcessor(
        pageNumber,
        pageSize
      );
    } else if (checkForUserRole(roles, userRoles.INSPECTOR.value)) {
      this.props.findAllRequestForSignetsApprovalsByInspector(
        pageNumber,
        pageSize
      );
    } else {
      this.props.findAllRequestForSignetsApprovalsPageble(pageNumber, pageSize);
    }
  };

  handlePreviewClose = () => {
    this.props.deleteErrorPhysicalEntity();
  };

  handlePageChange = (event, value) => {
    const {
      setActivePage,
      postData,
      pageSize,
      findAllRequestForSignetFilterPageable,
    } = this.props || {};
    setActivePage(value);
    postData
      ? findAllRequestForSignetFilterPageable(value, pageSize, postData)
      : this.handleFindAllTrigger(value, pageSize);
  };

  handleChangeRowsPerPage = (event, value) => {
    const {
      setPageSize,
      setActivePage,
      postData,
      findAllRequestForSignetFilterPageable,
    } = this.props || {};
    setPageSize(event.target.value);
    setActivePage(0);
    postData
      ? findAllRequestForSignetFilterPageable(0, event.target.value, postData)
      : this.handleFindAllTrigger(0, event.target.value);
  };

  showServerError = (isModalOpened) => {
    this.setState({ modalIsOpened: isModalOpened ? true : false });
    return isModalOpened ? false : true;
  };

  render() {
    const { error, totalElements, requestForSignetApprovalList } =
      this.props.requestForSignetApproval || {};
    const {
        t,
        isLoadingNeeded,
        deleteRequestForSignetApproval,
        createRequestForSignetApproval,
        findLastComplementRequestApprovalByRequestId,
        complementRequestApproval,
        clearComplementRequestApproval,
        deleteErrorRequestForSignetApproval,
        changeRequestForSignetApprovalStatus,
        createComplementRequestApproval,
        createDecision,
        findAllDecisionTypes,
        decisionTypeList,
        deleteErrorDecision,
        errorDecision,
        loggedUser,
        allowedActions,
        activePage,
        pageSize,
      } = this.props || {},
      { roles } = loggedUser || [],
      { items } = allowedActions || [];

    if (isLoadingNeeded) {
      return <LoadingIndicator />;
    }

    const isUserProcessor = checkForUserRole(roles, userRoles.MDULS.value);
    const isUserAuthorizedPerson = checkForUserRole(
      roles,
      userRoles.AUTHORIZED_PERSON.value
    );

    return (
      <Fragment>
        <RequestForSignetApprovalTable
          requestForSignetApprovalList={requestForSignetApprovalList}
          deleteRequestForSignetApproval={deleteRequestForSignetApproval}
          createRequestForSignetApproval={createRequestForSignetApproval}
          deleteError={deleteErrorRequestForSignetApproval}
          error={error}
          isModalOpened={this.isModalOpened}
          createDecision={createDecision}
          findAllDecisionTypes={findAllDecisionTypes}
          decisionTypeList={decisionTypeList}
          deleteErrorDecision={deleteErrorDecision}
          errorDecision={errorDecision}
          showServerError={this.showServerError}
          createComplementRequestApproval={createComplementRequestApproval}
          findAllRequestForSignetsApprovalsPageble={
            this.props.findAllRequestForSignetsApprovalsPageble
          }
          activePage={activePage}
          numberOfItemsPerPage={pageSize}
          changeRequestForSignetApprovalStatus={
            changeRequestForSignetApprovalStatus
          }
          findLastComplementRequestApprovalByRequestId={
            findLastComplementRequestApprovalByRequestId
          }
          complementRequestApproval={complementRequestApproval}
          clearComplementRequestApproval={clearComplementRequestApproval}
          isUserProcessor={isUserProcessor}
          isUserAuthorizedPerson={isUserAuthorizedPerson}
          allowedActions={items}
        />
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <TablePagination
            component="div"
            count={Number(totalElements)}
            page={activePage}
            onPageChange={this.handlePageChange}
            rowsPerPageOptions={rowsPerPageOptions}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPage={pageSize}
            labelRowsPerPage={t.rowPerPage}
            labelDisplayedRows={(obj) =>
              changePaginationTextToSerbian(obj, t.of)
            }
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  requestForSignetApproval: state.requestForSignetApproval,
  isLoadingNeeded: state.requestForSignetApproval.loading,
  decisionTypeList: state.decisionType.decisionTypeList,
  errorDecision: state.decision.error,
  complementRequestApproval:
    state.complementRequestApproval.complementRequestApproval,
  loggedUser: state.loggedUser?.loggedUser,
  allowedActions: state.loggedUser?.allowedActions,
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllRequestForSignetsApprovalsPageble: (pageNumber, pageSize) => {
      dispatch(findAllRequestForSignetsApprovalsPageble(pageNumber, pageSize));
    },
    createRequestForSignetApproval: (
      requestForSignetApproval,
      callback,
      callbackNotification,
      message
    ) => {
      dispatch(
        createRequestForSignetApproval(
          requestForSignetApproval,
          callback,
          callbackNotification,
          message
        )
      );
    },
    createComplementRequestApproval: (complementRequestApproval, callback) => {
      dispatch(
        createComplementRequestApproval(complementRequestApproval, callback)
      );
    },
    deleteRequestForSignetApproval: (id) => {
      dispatch(deleteRequestForSignetApproval(id));
    },
    deleteErrorRequestForSignetApproval: () => {
      dispatch(deleteErrorRequestForSignetApproval());
    },
    createDecision: (decision, callback) => {
      dispatch(createDecision(decision, callback));
    },
    findAllDecisionTypes: () => {
      dispatch(findAllDecisionTypes());
    },
    deleteErrorDecision: () => {
      dispatch(deleteErrorDecision());
    },
    changeRequestForSignetApprovalStatus: (id, status, callback) => {
      dispatch(changeRequestForSignetApprovalStatus(id, status, callback));
    },
    findAllRequestForSignetFilterPageable: (
      pageNumber,
      pageSize,
      postData,
      successCallback
    ) => {
      dispatch(
        findAllRequestForSignetFilterPageable(
          pageNumber,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    findLastComplementRequestApprovalByRequestId: (id) => {
      dispatch(findLastComplementRequestApprovalByRequestId(id));
    },
    clearComplementRequestApproval: () => {
      dispatch(clearComplementRequestApproval());
    },
    findAllRequestForSignetsApprovalsByProcessor: (pageNumber, pageSize) => {
      dispatch(
        findAllRequestForSignetsApprovalsByProcessor(pageNumber, pageSize)
      );
    },
    findAllRequestForSignetsApprovalsByInspector: (pageNumber, pageSize) => {
      dispatch(
        findAllRequestForSignetsApprovalsByInspector(pageNumber, pageSize)
      );
    },
    findAllRequestForSignetsApprovalsByClient: (
      userId,
      pageNumber,
      pageSize
    ) => {
      dispatch(
        findAllRequestForSignetsApprovalsByClient(userId, pageNumber, pageSize)
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withTranslations(RequestForSignetApprovalList, 'RequestForSignetApprovalList')
);
